import { gql } from "@apollo/client";

export default gql`
  mutation SetGroupProducts($id: ObjectId!, $products: [ObjectId!]!, $outsideProducts: [OutsideProductInput!]!) {
    setGroupProducts(id: $id, products: $products, outsideProducts: $outsideProducts) {
      _id
      productsCount
      products {
        _id
        name
        logo
        slug
        company {
          _id
          name
          slug
        }
      }
      outsideProducts {
        _id
        name
        url
        logo
      }
    }
  }
`;
